// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"778":"a880b39c","787":"a3a4ea72"}[chunkId] + ".chunk.js";
};